/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { DataGridCustom, Input, Grid, Button, SelecaoMultipla, RadioComLabel } from '../../components';
import {
  opcaoFiltroTipoParticipacao,
  tipoRegime,
} from '../../utils/listsSelect';
import { doGet } from '../../utils/requests';
import SelecaoEntidade from './SelecaoEntidade';
import SelecaoSuperintendencia from './SelecaoSuperintendencia';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';

const participanteRGPS = '01000';

class FiltroRelatorioTotalizadorEstados extends Component {
  constructor() {
    super();
    if(this.props && this.props.nomeFiltro){
      this.filtroRelatorioTotalizador = JSON.parse(sessionStorage.getItem(this.props.nomeFiltro));
    }
    this.state = {
      tipoRegime: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.tipoRegime ?
        this.filtroRelatorioTotalizador.tipoRegime : null,
      tipoRegimeObservador: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.tipoRegimeObservador ?
        this.filtroRelatorioTotalizador.tipoRegimeObservador : null,
      tipoEntidade: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.tipoEntidade ?
        this.filtroRelatorioTotalizador.tipoEntidade : null,
      tipoEntidadeObservador: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.tipoEntidadeObservador ?
        this.filtroRelatorioTotalizador.tipoEntidadeObservador : null,
      uf: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.uf ?
        this.filtroRelatorioTotalizador.uf : null,
      uFObservador: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.uFObservador ?
        this.filtroRelatorioTotalizador.uFObservador : null,
      participante: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.participante ?
        this.filtroRelatorioTotalizador.participante : null,
      participanteObservador: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.participanteObservador ?
        this.filtroRelatorioTotalizador.participanteObservador : null,
      superintendencia: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.superintendencia ?
        this.filtroRelatorioTotalizador.superintendencia : null,
      gex: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.gex ?
        this.filtroRelatorioTotalizador.gex : null,
      aps: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.aps ?
        this.filtroRelatorioTotalizador.aps : null,
      visao: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.visao ?
        this.filtroRelatorioTotalizador.visao : null,
      opcao: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.opcao ?
        this.filtroRelatorioTotalizador.opcao : null,
      estado: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.estado ?
        this.filtroRelatorioTotalizador.estado : null,
      consultaPorVisao: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.consultaPorVisao ?
        this.filtroRelatorioTotalizador.consultaPorVisao : null,
      configComponenteSelecaoMultipla: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.configComponenteSelecaoMultipla ?
        this.filtroRelatorioTotalizador.configComponenteSelecaoMultipla : null,
      lista: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.lista ?
        this.filtroRelatorioTotalizador.lista : [],
      valorComboSelecaoMultipla: this.filtroRelatorioTotalizador && this.filtroRelatorioTotalizador.valorComboSelecaoMultipla ?
        this.filtroRelatorioTotalizador.valorComboSelecaoMultipla : null,
      listaSuperintendencias: [],
      listaGexs: [],
      listaAps: [],
      listaEntes: [],
      listaTiposRegimes: [],
      listaTiposRegimesOutrosPapeis: [],
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem(this.props.nomeFiltro)) {
      this.handleSearch();
    }
    this.carregaUnidadesOrganicas(24, null, this.carregaSuperintendencias);
    this.carregarListaTiposRegimes();
  }

  configurarSelecaoMultipla = (estado) => {
    let configuracao;
    switch (estado) {
      case '2':
        configuracao = {
          // listaSource: this.props.exigencias,
          labelCombobox: "Exigência",
          titulo: "Tipos de exigência",
          exibirBotaoIncluir: true,
          exibirTabelaItens: true,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
      case '9':
        configuracao = {
          // listaSource: this.props.motivosIndeferimento,
          labelCombobox: "Motivo de indeferimento",
          titulo: "Tipos de indeferimento",
          exibirBotaoIncluir: true,
          exibirTabelaItens: true,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
      case '10':
        configuracao = {
          // listaSource: this.props.motivosSuspensao,
          labelCombobox: "Motivo de suspensão",
          titulo: "Tipos de suspensão",
          exibirBotaoIncluir: false,
          exibirTabelaItens: false,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
        case '12':
          configuracao = {
            // listaSource: this.props.motivosCessacao,
            labelCombobox: "Motivo de cessação",
            titulo: "Tipos de cessação",
            exibirBotaoIncluir: false,
            exibirTabelaItens: false,
            retirarLinhaSeparadora: false,
            exibirComboBox: true,
          }
          break;
      default:
        configuracao = {
          // listaSource: [],
          labelCombobox: "",
          titulo: "",
          exibirBotaoIncluir: false,
          exibirTabelaItens: false,
          retirarLinhaSeparadora: true,
          exibirComboBox: false,
        }  
          break;
        }
        return configuracao;
  }

  filtrarRegimes = () => {
    let retorno = this.state.listaTiposRegimes;
    if (this.props.papelUsuarioLogado === 'analista-rgps' ||
    (this.state.tipoRegimeObservador === 1 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = this.state.listaTiposRegimes.filter(item => (item.label !== 'RGPS'));
    }
    if ((this.state.tipoRegimeObservador === 2 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = tipoRegime;
    } 
    this.setState({ listaTiposRegimes: retorno});
  }

  handleChangeOpcao = (value) => {
    this.filtrarRegimes();
    let ehVisao = false;
    if ([2, 3].includes(value)) {
      ehVisao = true;
    } else {
      ehVisao = false;
    }

    this.setState(
      { 
        opcao: value,
        consultaPorVisao: ehVisao,
      }, () => this.limparFormulario(value)
    );
  }

  handleChange = (changeObj, name, callback = null) => {
    let configuracao = this.state.configComponenteSelecaoMultipla;
    let limparCampos = false;

    if (name === 'estado') {
      configuracao = this.configurarSelecaoMultipla(changeObj.value);
      this.setState({lista: []});
    }

    if (name === 'tipoRegimeObservador') {
      if (changeObj.value === 1) {
        this.setState({participanteObservador: participanteRGPS});
      }
      this.setState({tipoRegimeObservador: changeObj.value}, this.filtrarRegimes);
      
      // if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
      //   limparCampos = true;
      // }
    }

    if (name === 'tipoRegime') {
      if (changeObj.value === 1) {
        this.setState({participante: participanteRGPS});
      }      
      // if (this.state.tipoRegime && (this.state.tipoRegime !== changeObj.value)) {
      //   limparCampos = true;
      // }
    }

    if (name === 'estado') {
      if (this.state.valorComboSelecaoMultipla !== null && (this.state.valorComboSelecaoMultipla !== changeObj.value)) {
        limparCampos = true;
      }
    }

    if(callback === null) {
      callback = () => this.trataFormulario(limparCampos, name);
    }

    // if(callback === 'filtrarRegimes') {
    //   callback = () => this.filtrarRegimes();
    // }

    this.setState({
      [name]: changeObj.value,
      configComponenteSelecaoMultipla: configuracao,
    }, callback,
    );
  }

  handleChangeRadio = (changeObj, name) => {
    this.setState({ [name]: changeObj.value, consultaPorVisao: true });
  };

  trataFormulario = (limparCampos, campoAlterado) => {
    if (campoAlterado === 'tipoRegimeObservador' && limparCampos) {
      this.setState({ 
        tipoEntidadeObservador: null,
        uFObservador: null,
        participanteObservador: null,
        opcao: null,
        participante: null,
        tipoEntidade: null,
        uf: null,
      });
    }
    if (campoAlterado === 'tipoRegime' && limparCampos) {
      this.setState({ tipoEntidade: null, uF: null, participante: null });
    }

    if (campoAlterado === 'estado' && limparCampos) {
      this.setState({ valorComboSelecaoMultipla: null });
    }

    if (campoAlterado === 'tipoEntidade') {
      this.setState({ participante: null, uf: null });
    }
    if (campoAlterado === 'uf') {
      this.setState({ participante: null });
    }
    if (campoAlterado === 'superintendencia') {
      this.setState({ gex: null, aps: null, ente: null });
      if (this.state.superintendencia) {
        this.carregaUnidadesOrganicas(3, this.state.superintendencia, this.carregaGexs);
      }
    }
    if (campoAlterado === 'gex') {
      this.setState({ aps: null, ente: null });
      if (this.state.gex) {
        this.carregaUnidadesOrganicas(4, this.state.gex, this.carregaAps);
      }
    }
  }

  limparFormulario = (valor) => {
    if (valor === '' || ((valor === 2 || valor === 3) && this.state.tipoEntidade !== null)) {
      this.setState({ tipoEntidade: null });
    }
    if (((valor === 2 || valor === 3) && this.state.participante !== null)) {
      this.setState({ participante: null });
    }
    if (this.state.tipoRegime !== null) {
      this.setState({ tipoRegime: null });
    }
    if (this.state.superintendencia !== null) {
      this.setState({ superintendencia: null });
    }
    if (this.state.gex !== null) {
      this.setState({ gex: null });
    }
    if (this.state.visao !== null) {
      this.setState({ visao: null });
    }

    this.props.observardorDeMudanca();
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  carregarListaTiposRegimes = () => {
    this.setState({ listaTiposRegimes: tipoRegime });
  }

  carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
    const parametros = {};
    if (codigoSuperior) {
      parametros.codigoSuperior = codigoSuperior;
    }
    if (categoria) {
      parametros.categoria = categoria;
    }
    doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
  }

  carregaSuperintendencias = (response) => {
    const superintendencias = [];
    response.data.forEach((item) => {
      superintendencias.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaSuperintendencias: superintendencias });
  }

  carregaGexs = (response) => {
    const gexs = [];
    response.data.forEach((item) => {
      gexs.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaGexs: gexs });
  }

  carregaAps = (response) => {
    const aps = [];
    response.data.forEach((item) => {
      aps.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaAps: aps });
  }

  carregaEntesFederativos = (aps) => {
    const parametros = { aps };
    doGet('entes-federativos', this.tratarSucessoEntesFederativos, this.tratarErro, parametros);
  }

  tratarSucessoEntesFederativos = (response) => {
    const entes = [];
    response.data.forEach((item) => {
      entes.push({
        label: item.nomeRpps,
        value: item.idParticipante,
      });
    });
    this.setState({ listaEntes: entes });
  }

  validaNaoEhSuperintendenciaESelecionouAmbos = () => {
    const opcaoAmbos = 1;
    return (!this.state.superintendencia && this.state.opcao === opcaoAmbos);
  }

  validaEhPapelObservador = () => {
    return ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && !this.state.tipoRegimeObservador;
  }

  validaEhPapelObservadorERegimeSelecionado = () => {
    return ((this.props.papelUsuarioLogado === 'analista-rgps') && this.state.opcao !== 1) ||
    (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && this.state.tipoRegimeObservador === 1 && this.state.opcao !== 1);
  }

  verificarTextoHintBotaoInclusao = () => {
    let retorno = 'item';
    switch (this.state.estado) {
      case '2':
        retorno = 'exigência';
        break;
      case '9':
        retorno = 'motivo';
        break;
      default:
        break;
    }
    return retorno;
  }

  montaFiltrosDefault = () => (
    <React.Fragment>
      {ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) ?
        <SelecaoEntidade
          handleChange={this.handleChange}
          destinatarios={this.props.destinatarios}
          papelUsuarioLogado={this.props.papelUsuarioLogado}
          titulo="Visualizar como"
          retirarLinhaSeparadora={false}
          tipoRegime={this.state.tipoRegimeObservador}
          tipoEntidade={this.state.tipoEntidadeObservador}
          uf={this.state.uFObservador}
          participante={this.state.participanteObservador}
          nomeAtributoComboboxRegime="tipoRegimeObservador"
          nomeAtributoComboboxParticipante="participanteObservador"
          nomeAtributoComboboxTipoEntidade="tipoEntidadeObservador"
          nomeAtributoComboboxUF="uFObservador"
          listaTiposRegimes={tipoRegime}
          labelComboboxParticipante="Participante Observador"
        />
      : '' }
      <DataGridCustom title="Filtro básico">
        <div className="row">
          <Grid cols="12 12 12 12">
            <RadioComLabel
              value={this.state.opcao}
              name="opcao"
              itemList={opcaoFiltroTipoParticipacao}
              onChange={value => this.handleChangeOpcao(value)}
              animate={false}
              label="Opção"
              disabled={this.validaEhPapelObservador()}
              disposicao='horizontal'
              required
            />
          </Grid>
        </div>
        {this.validaNaoEhSuperintendenciaESelecionouAmbos() ? (
          <SelecaoEntidade
            handleChange={this.handleChange}
            destinatarios={this.props.destinatarios}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            titulo=""
            retirarLinhaSeparadora={true}
            tipoRegime={this.state.tipoRegime}
            tipoEntidade={this.state.tipoEntidade}
            uf={this.state.uf}
            participante={this.state.participante}
            nomeAtributoComboboxRegime="tipoRegime"
            nomeAtributoComboboxParticipante="participante"
            nomeAtributoComboboxTipoEntidade="tipoEntidade"
            nomeAtributoComboboxUF="uf"
            listaTiposRegimes={this.state.listaTiposRegimes}
            labelComboboxParticipante="Participante"
          />
        ) : ''}
        {this.validaEhPapelObservadorERegimeSelecionado() ? (
          <SelecaoSuperintendencia
            handleChange={this.handleChange}
            tipoRegime={this.state.tipoRegime}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            listaSuperintendencias={this.state.listaSuperintendencias}
            listaGexs={this.state.listaGexs}
            listaAps={this.state.listaAps}
            superintendencia={this.state.superintendencia}
            gex={this.state.gex}
            aps={this.state.aps}
            tipoRegimeObservador={this.state.tipoRegimeObservador}
            titulo=""
            retirarLinhaSeparadora={true}
          />
        ) : ''}
      </DataGridCustom>
    </React.Fragment>
  )

  handleSearch = () => {
    const participanteObservadorSelecionado = this.state.participanteObservador;
    const regimeSelecionado = this.state.tipoRegime;
    const entidadeSelecionada = this.state.tipoEntidade;
    const ufSelecionada = this.state.uf;    
    const participanteSelecionado = this.state.participante;
    const opcaoSelecionada = this.state.opcao;
    const superintendenciaSelecionada = this.state.superintendencia;

    if (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && !participanteObservadorSelecionado) {
      this.addMessage('Selecione o participante Observador.');
      return;
    }

    if (!opcaoSelecionada) {
      this.addMessage('Selecione uma opção.');
      return;
    }
    // refatorar essa parte
    if (this.props.papelUsuarioLogado === 'analista-rgps' || participanteObservadorSelecionado === '01000') {
      if (opcaoSelecionada && opcaoSelecionada === 1) {
        if (!regimeSelecionado) {
          this.addMessage('Selecione um regime.');
          return;
        }
        if (regimeSelecionado !== 1 && !entidadeSelecionada) {
          this.addMessage('Selecione uma entidade.');
          return;
        }
        if ((entidadeSelecionada && entidadeSelecionada === 2) && ufSelecionada === null) {
          this.addMessage('Selecione uma UF.');
          return;
        }
        if (!participanteSelecionado) {
          this.addMessage('Selecione um participante.');
          return;
        }
      } else if ((opcaoSelecionada && opcaoSelecionada !== 1)) {
        if (!superintendenciaSelecionada) {
          this.addMessage('Selecione uma superintendência.');
          return;
        }
      }
    } else {
      if (opcaoSelecionada && opcaoSelecionada === 1) {
        if (!regimeSelecionado) {
          this.addMessage('Selecione um regime.');
          return;
        }
        if (regimeSelecionado !== 1 && !entidadeSelecionada) {
          this.addMessage('Selecione uma entidade.');
          return;
        }
        if ((entidadeSelecionada && entidadeSelecionada === 2) && ufSelecionada === null) {
          this.addMessage('Selecione uma UF.');
          return;
        }
        if (!participanteSelecionado) {
          this.addMessage('Selecione um participante.');
          return;
        }
      }
    }

    this.props.handleSearchFilter(this.state);

  }

  handleSearchButton = () => {
    let filtroRelatorioTotalizador = {
      tipoRegime: this.state.tipoRegime,
      tipoRegimeObservador: this.state.tipoRegimeObservador,
      tipoEntidade: this.state.tipoEntidade,
      tipoEntidadeObservador: this.state.tipoEntidadeObservador,
      uf: this.state.uf,
      uFObservador: this.state.uFObservador,
      participante: this.state.participante,
      participanteObservador: this.state.participanteObservador,
      superintendencia: this.state.superintendencia,
      gex: this.state.gex,
      aps: this.state.aps,
      visao: this.state.visao,
      opcao: this.state.opcao,
      estado: this.state.estado,
      consultaPorVisao: this.state.consultaPorVisao,
      lista: this.state.lista,
      configComponenteSelecaoMultipla: this.state.configComponenteSelecaoMultipla,
      valorComboSelecaoMultipla: this.state.valorComboSelecaoMultipla,
    };

    filtroRelatorioTotalizador = JSON.stringify(filtroRelatorioTotalizador);
    sessionStorage.setItem(this.props.nomeFiltro, filtroRelatorioTotalizador);

    this.handleSearch();
  }

  render() {
    const filtrosPesquisa = this.montaFiltrosDefault();

    if (!filtrosPesquisa) {
      return null;
    }

    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="relatorio"
          panelId="filtro-relatorio"
          icon="ico-filter"
          title={`${this.props.tipo}`}
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroRelatorioTotalizadorEstados.propTypes = {
  handleSearchFilter: PropTypes.func,
  observardorDeMudanca: PropTypes.func,
  papelUsuarioLogado: PropTypes.string,
  nomeFiltro: PropTypes.string,
}.isRequired;

export default FiltroRelatorioTotalizadorEstados;



// WEBPACK FOOTER //
// ./src/pages/relatorios/FiltroRelatorioTotalizadorEstados.jsx